var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "columns is-multiline d-flex flex-column flex-md-row" },
    [
      _c(
        "section",
        {
          staticClass: "sidebar column is-full-mobile is-4-tablet is-3-desktop"
        },
        [
          _c("cat-uxo-call-to-action", { staticClass: "mb-4 shape--top" }),
          _vm._v(" "),
          _c(
            "a",
            { staticClass: "btn w-100 mb-4", attrs: { href: "/contribute" } },
            [_vm._v("Contribute a New Hazard")]
          ),
          _vm._v(" "),
          _c("cat-uxo-stacked-ads")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "uxo-type column is-offset-1-desktop is-8 p-0" },
        [
          !_vm.loading
            ? [
                _c(
                  "div",
                  { staticClass: "flex w-full flex-col space-y-4" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex w-full" }, [
                      _c(
                        "form",
                        {
                          staticClass:
                            "form form-search d-flex justify-content-center w-full",
                          attrs: { action: "/search" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "field position-relative w-100" },
                            [
                              _c("div", { staticClass: "control" }, [
                                _c("input", {
                                  staticClass: "input w-100 rounded-xl",
                                  attrs: {
                                    name: "query",
                                    type: "text",
                                    placeholder: "E.g. Type 58 Landmine"
                                  },
                                  domProps: { value: _vm.query }
                                })
                              ]),
                              _vm._v(" "),
                              _vm._m(1)
                            ]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.search
                      ? [
                          _vm._l(Object.keys(_vm.search), function(i) {
                            return [
                              _vm.search[i].length
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex cap flex-col border rounded-xl bg-white p-1"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex justify-between bg-[#143642] p-1 px-2 w-full rounded-[9px]"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                " capitalize text-white text-sm font-medium"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(i.replace("_", " ")) +
                                                  "\n                                "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex flex-col space-y-4 p-2"
                                        },
                                        [
                                          _vm._l(_vm.search[i], function(
                                            record
                                          ) {
                                            return [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "flex group w-full justify-between cursor-pointer",
                                                  attrs: {
                                                    href: record.permalink
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex pr-4 space-x-4 w-full"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "w-10 h-10 flex"
                                                        },
                                                        [
                                                          _c("img", {
                                                            staticClass:
                                                              "my-auto w-10 object-fit",
                                                            attrs: {
                                                              src: record.image
                                                            }
                                                          })
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "my-auto text-sm font-medium group-hover:text-[#E57722]"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(record.name)
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "svg",
                                                    {
                                                      staticClass:
                                                        "fill-current my-auto text-[#E57722] w-2.5",
                                                      attrs: {
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 320 512"
                                                      }
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          d:
                                                            "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          })
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          })
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    !Object.values(this.search).some(function(value) {
                      return Array.isArray(value) && value.length > 0
                    })
                      ? _c("div", [
                          _c(
                            "div",
                            { staticClass: "font-medium text-[#143642]" },
                            [
                              _vm._v(
                                "No results found matching your search query."
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ],
                  2
                )
              ]
            : [
                _c("div", { staticClass: "w-full h-full flex" }, [
                  _c(
                    "div",
                    {
                      staticClass: "mx-auto flex flex-col mt-20",
                      attrs: { role: "status" }
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass:
                            "inline mx-auto w-14 h-14 text-[#143642] animate-spin fill-[#E57722]",
                          attrs: {
                            "aria-hidden": "true",
                            viewBox: "0 0 100 101",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              d:
                                "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                              fill: "currentColor"
                            }
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d:
                                "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                              fill: "currentFill"
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "font-medium text-[#143642] mt-4" },
                        [_vm._v("Searching CAT-UXO database...")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("Loading...")
                      ])
                    ]
                  )
                ])
              ]
        ],
        2
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex" }, [
      _c("h1", { staticClass: "h2 font-weight-normal t-black" }, [
        _vm._v("Search")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "control" }, [
      _c("button", {
        staticClass: "btn btn-search !rounded-tr-xl !rounded-br-xl"
      })
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b8caf91", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b8caf91","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/PlatformSearch.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6b8caf91","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/PlatformSearch.vue
// module chunks = 0 1